<template>
  <div class="shipments-view">
    <div
      class="link--old--layout"
    >
      <router-link  to="/shipments-by-day">Go to new Shipments layout</router-link>
    </div>
    <ContainerLayout :isOverview="isOverview">
      <template v-slot:contentPart>
        <keep-alive>
         <component :is="dynamicComponent.content"/>
        </keep-alive>
        <!-- <component v-if="dynamicComponent.content !== 'ShipmentsMapContent'" :is="dynamicComponent.content"/> -->
      </template>
      <template v-slot:contextActionPanel>
          <ActionPanel :selectedView="selectedView" :actions="actionsForPanel" >
            <template v-slot:extraButtons >
              <ExportScheduleList v-if="getSelectedResourceID.objectID !== null"/>
            </template>
          </ActionPanel>

      </template>
      <template v-slot:contextPart>
        <component :is="dynamicComponent.context"/>
      </template>
      <template v-slot:contextFooter>
        <ContextFooterRM/>
      </template>
    </ContainerLayout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContainerLayout from '@/components/wrld/generic/ContainerLayout'
import ActionPanel from '@/components/wrld/generic/ActionPanel'
import ContextFooterRM from '@/components/wrld/generic/ContextFooterRM'

import ShipmentsOverviewContent from '@/components/shipments/new/ShipmentsOverviewContent'
import ShipmentsOverviewContext from '@/components/shipments/new/ShipmentsOverviewContext'
import ShipmentsScheduleContent from '@/components/shipments/new/schedule/ShipmentsScheduleContent'
import ShipmentsMapContent from '@/components/shipments/new/ShipmentsMapContent'
import ShipmentsDropsContent from '@/components/shipments/new/drops/ShipmentsDropsContent'
import ShipmentsQuoteContent from '@/components/shipments/new/quoting/ShipmentsQuoteContent'
import ShipmentsDetailContext from '@/components/shipments/new/ShipmentsDetailContext'
import ExportScheduleList from '@/components/shipments/new/ExportScheduleList'

export default {
  name: 'Shipmentss',
  components: {
    ContainerLayout,
    ActionPanel,
    ContextFooterRM,
    ShipmentsOverviewContent,
    ShipmentsOverviewContext,
    ShipmentsScheduleContent,
    ShipmentsQuoteContent,
    ShipmentsDetailContext,
    ExportScheduleList,
    ShipmentsMapContent,
    ShipmentsDropsContent
  },
  props: {
    selectedView: String
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getSelectedResource',
      'getSelectedResourceID',
      'getContentLastUrl',
      'getLoggedInUserRole',
      'getLoggedInUserOrganizationID'
    ]),
    isOverview () {
      return this.selectedView === 'overview'
    },
    actionsForPanel () {
      let availableActions = {
        // detail: {
        //   icon: 'fas fa-info-circle',
        //   name: this.$i18n.t('detail'),
        //   callback: this.goToDetail
        // },
        schedule: {
          key: 'schedule',
          roles: ['all'],
          icon: 'fas fa-clipboard-list',
          name: this.$i18n.t('shipments.schedule'),
          callback: this.goToSchedule
        },
        back: {
          key: 'back',
          roles: ['all'],
          icon: 'fas fa-arrow-circle-left',
          name: this.$t('buttons.back'),
          callback: this.goToOverview
        },
        map: {
          key: 'map',
          roles: ['all'],
          icon: 'far fa-map',
          name: this.$t('locations.map'),
          callback: this.goToMap
        },
        drops: {
          key: 'drops',
          roles: ['Admins', 'Dispatchers'],
          icon: 'fas fa-pallet',
          name: this.$t('drops.drops'),
          callback: this.goToDrops
        },
        quote: {
          key: 'quote',
          roles: ['all'],
          isFeatherIcon: true,
          icon: 'FileTextIcon',
          name: this.$t('quotes.quote'),
          callback: this.goToQuote
        }
      }
      let panelActions = []
      switch (this.selectedView) {
        case 'overview':
          if (this.getSelectedResourceID.objectID !== null) {
            ['quote', 'schedule', 'map', 'drops'].forEach((key) => {
              panelActions.push(availableActions[key])
            })
          }
          break
        case 'schedule':
          ['back', 'quote', 'schedule', 'map', 'drops'].forEach((key) => {
            panelActions.push(availableActions[key])
          })
          break
        case 'map':
          ['back', 'quote', 'schedule', 'map', 'drops'].forEach((key) => {
            panelActions.push(availableActions[key])
          })
          break
        case 'drops':
          ['back', 'quote', 'schedule', 'map', 'drops'].forEach((key) => {
            panelActions.push(availableActions[key])
          })
          break
        case 'quote':
          ['back', 'quote', 'schedule', 'map', 'drops'].forEach((key) => {
            panelActions.push(availableActions[key])
          })
          break
        default: // default is overview
          panelActions.push(
            {
              icon: 'fas fa-info-circle',
              name: this.$i18n.t('schedule'),
              callback: this.goToSchedule
            }

          )
          break
      }
      return panelActions
    },
    dynamicComponent () {
      switch (this.selectedView) {
        case 'overview':
          return {
            content: 'ShipmentsOverviewContent',
            context: 'ShipmentsOverviewContext'
          }
        case 'schedule':
          return {
            content: 'ShipmentsScheduleContent',
            context: 'ShipmentsDetailContext'
          }
        case 'map':
          return {
            content: 'ShipmentsMapContent',
            context: 'ShipmentsDetailContext'
          }
        case 'drops':
          return {
            content: 'ShipmentsDropsContent',
            context: 'ShipmentsDetailContext'
          }
        case 'quote':
          return {
            content: 'ShipmentsQuoteContent',
            context: 'ShipmentsDetailContext'
          }
        default: // default is overview
          return {
            content: 'ShipmentsOverviewContent',
            context: 'ShipmentsOverviewContext'
          }
      }
    }
  },
  methods: {
    ...mapActions({
      clearResourceStore: 'clearResourceStore',
      setContentLastUrl: 'setContentLastUrl',
      setIsShipmentDetails: 'setIsShipmentDetails',
      fetchQuoteList: 'fetchQuoteList',
    }),
    goToSchedule (resourceID) {
      this.setIsShipmentDetails({ flag: true })
      if (this.getSelectedResourceID.objectID !== null) {
        if (this.selectedView === 'overview') {
          this.setContentLastUrl({ url: this.$route.fullPath })
        }
        this.$router.push({ name: 'ShipmentsSchedule', params: { shipmentID: this.getSelectedResourceID.objectID != null ? this.getSelectedResourceID.objectID : this.$route.params.shipmentID } })
      }
    },
    goToMap (resourceID) {
      this.setIsShipmentDetails({ flag: true })
      if (this.selectedView === 'overview') {
        this.setContentLastUrl({ url: this.$route.fullPath })
      }
      this.$router.push({ name: 'ShipmentsMap', params: { shipmentID: this.getSelectedResourceID.objectID != null ? this.getSelectedResourceID.objectID : this.$route.params.shipmentID } })
    },
    goToDrops (resourceID) {
      this.setIsShipmentDetails({ flag: true })
      if (this.selectedView === 'overview') {
        this.setContentLastUrl({ url: this.$route.fullPath })
      }
      this.$router.push({ name: 'ShipmentsDrops', params: { shipmentID: this.getSelectedResourceID.objectID != null ? this.getSelectedResourceID.objectID : this.$route.params.shipmentID } })
    },
    goToQuote (resourceID) {
      this.setIsShipmentDetails({ flag: true })
      if (this.selectedView === 'overview') {
        this.setContentLastUrl({ url: this.$route.fullPath })
      }
      const shipmentID =  this.getSelectedResourceID.objectID != null ? this.getSelectedResourceID.objectID : this.$route.params.shipmentID
      this.fetchQuoteList({ shipmentID })
      this.$router.push({ name: 'ShipmentsQuote', params: { shipmentID } })
    },
    goToOverview (resourceID) {
      this.setIsShipmentDetails({ flag: false })
      const url = this.getContentLastUrl
      if (url !== null) {
        this.$router.push({ path: url })
      } else {
        this.$router.push({ name: 'ShipmentsOverview' })
      }
    }
  },
  created () {
    this.clearResourceStore()
  }

}
</script>
<style lang="scss" scoped>
  .link--old--layout {
    width: 100% !important;
    display: block !important;
    font-weight: 600 !important;
    color: #0073bb !important;
    text-align: right !important;
    padding-right: 10px;
    font-size: 14px;
    a {
      font-weight: 600 !important;
      color: #0073bb !important;
      text-align: right !important;
    }
  }
</style>
